module.exports = __webpack_public_path__ + "static/sub-2d3fc14c628af1b1d5b924d88502edfe.jpg";